import {DimensionUnit, WeightUnit} from '../../../../_gori/constants'
import {PaginateModel} from '../../../../_gori/partials/widgets/paginate/core/_models'
import {ShippingAddress} from './address'
import {SenderType} from './sender'

export const MESSAGE_CONTAINER_ID = 'scrollableDiv'

export const FORMAT_CHATBOT_DATE_TIME = 'YYYY-MM-DD HH:mm:ss'

export const TYPING_TEXT_DURATION = {
  NORMAL: 50,
  FASTER: 25,
} as const

export const MESSAGE_TYPE = {
  TEXT: 'text',
  DATE_PICKER: 'date-picker',
  DATE_RANGE_PICKER: 'date-range-picker',
  OPTION_SELECT: 'option-select',
  DROPDOWN_SELECT: 'dropdown-select',
  LINK_BOX: 'link-box',
  LINK: 'link',
  TRACKING_SHIPMENT: 'tracking-shipment',
  SURVEY: 'survey',
  ADDRESS: 'address',
  SELECT_SERVICE: 'select-service',
  REVIEW_ORDER: 'review-order',
  CONFIRM_ORDER_INFO: 'confirm-order-info',
  ORDER_INFO: 'order-info',
} as const

export type MessageType = typeof MESSAGE_TYPE[keyof typeof MESSAGE_TYPE]

export const MESSAGE_ACTION = {
  LIKE: 'like',
  DISLIKE: 'dislike',
}

export type MessageAction = typeof MESSAGE_ACTION[keyof typeof MESSAGE_ACTION]

export type A1FlightInfo = {
  from: string
  to: string
  layover?: string[]
  latest_flight: string
  status: string
}

export type MessageTypeShipmentStatusContent = {
  ship_from: ShippingAddress
  ship_to: ShippingAddress
  waypoints: (ShippingAddress & {
    status: string
  })[]
  estimated_delivery_at: string
  delivered_at?: string
  status: string
  delay?: {
    delay_time: string
    delay_reason: string
  }
  a1_flight_info?: A1FlightInfo
}

export type MessageOption = {
  label: string
  value: string
  selected?: boolean
  default?: boolean
}

export type MessageDimension = {
  length: string
  width: string
  height: string
  dimension_unit: DimensionUnit
  weight_unit: WeightUnit
  weight: string
}

export type MessageOrderInfo = {
  from: MessageAddress
  to: MessageAddress
  dimension: MessageDimension[]
  disabled?: boolean
}

export type MessageAddress = {
  street1: string
  city: string
  state: string
  zip: string
  country: string
}

export type ServiceOption = {
  logo: string
  carrier_service: string
  cost: string
  ETA: string
  selected: boolean
  services?: string // chỉ có ở "best"
}
export type MessageSelectService = {
  best: ServiceOption
  cheapest: ServiceOption
  fastest: ServiceOption
  option?: 'label' | 'order'
  disabled?: boolean
}

export type MessageDateTimeRangePayload = {
  name: 'date_range'
  value: {
    start_date: string
    end_date: string
  }
  disabled?: boolean
}

export type HandleCreateMessageParams = CreateMessagePayload & {
  newMessageId?: string | number
  currentMessageId?: string | number
}

export type MessageModel<T> = {
  id: number | string
  chat_conversation_id: number | string
  content: T
  // content: any
  sender: SenderType
  type: MessageType
  created_at: string
  updated_at?: string
  // TODO: [N] wait for the backend to implement
  options?: MessageOption[]
  url?: string
  error?: string
  action?: null | MessageAction
}

export type MessageContent =
  | string
  | MessageOption
  | MessageDateTimeRangePayload
  | MessageDimension[]
  | MessageAddress
  | MessageSelectService
  | MessageOrderInfo

export type MessageItemCommonProps<T> = {
  message: MessageModel<T>
  className?: string
}

export type MessageResponse = {
  conversation: MessageModel<MessageContent>[]
  pagination: PaginateModel
}

export type CreateMessagePayload = {
  message: (
    | string
    | MessageOption
    | MessageDateTimeRangePayload
    | MessageDimension[]
    | MessageAddress
    | MessageSelectService
    | MessageOrderInfo
  ) & {disabled?: boolean}
  type: MessageType
  id?: string | number
}

export type MessageResponseCommon = {
  id: number | string
  created_at: string
}

type MessageResponseText = MessageResponseCommon & {
  type: 'text'
  content: string[]
}
type MessageResponseDimension = MessageResponseCommon & {
  type: 'dimension'
  content: MessageDimension[]
}

type MessageResponseAddress = MessageResponseCommon & {
  type: 'address'
  content: MessageAddress
}
type MessageResponseSelectService = MessageResponseCommon & {
  type: 'select-service'
  content: MessageSelectService
}

type MessageResponseDateRangePicker = MessageResponseCommon & {
  type: 'date-range-picker'
  content: {
    name: string
    value: {
      start_date: string | null
      end_date: string | null
    }
  }
}
type MessageResponseOptionSelect = MessageResponseCommon & {
  type: 'option-select'
  content: MessageOption
}

type MessageResponseTrackingShipment = MessageResponseCommon & {
  type: 'tracking-shipment'
  content: MessageTypeShipmentStatusContent
}
type MessageResponseDropdownSelect = MessageResponseCommon & {
  type: 'dropdown-select'
  content: {
    options: MessageOption[]
  }
}

export type CreateMessageResponse = (
  | MessageResponseText
  | MessageResponseTrackingShipment
  | MessageResponseOptionSelect
  | MessageResponseDropdownSelect
  | MessageResponseDateRangePicker
  | MessageResponseDimension
  | MessageResponseAddress
  | MessageResponseSelectService
)[]
